(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll() {
    document.querySelectorAll('.ampion-reveal, .ampion-power-bar[data-autocharge]').forEach(function (el) {
      el.classList.add('is-visible');
      el.classList.add('is-charged');
    });
  }

  if (reduceMotion) {
    revealAll();
    return;
  }

  // Word-by-word cascade for big headings.
  document.querySelectorAll('.ampion-heading-xl.ampion-reveal, .ampion-heading-lg.ampion-reveal').forEach(function (h) {
    if (h.children.length) return; // only split plain-text headings
    var words = h.textContent.trim().split(/\s+/);
    h.textContent = '';
    words.forEach(function (word, i) {
      var span = document.createElement('span');
      span.className = 'ampion-word';
      span.style.setProperty('--word-i', i);
      span.textContent = word;
      h.appendChild(span);
      if (i < words.length - 1) h.appendChild(document.createTextNode(' '));
    });
    h.classList.add('ampion-words');
  });

  // Auto-stagger sibling reveals that have no explicit delay.
  var groups = new Map();
  document.querySelectorAll('.ampion-reveal').forEach(function (el) {
    if (el.style.transitionDelay) return;
    var parent = el.parentElement;
    var i = groups.get(parent) || 0;
    if (i > 0) el.style.transitionDelay = Math.min(i * 90, 540) + 'ms';
    groups.set(parent, i + 1);
  });

  // Scroll progress bar with glowing tip.
  var progress = document.createElement('div');
  progress.className = 'ampion-scroll-progress';
  progress.setAttribute('aria-hidden', 'true');
  var progressFill = document.createElement('div');
  progressFill.className = 'ampion-scroll-progress__fill';
  progress.appendChild(progressFill);
  document.body.appendChild(progress);
  var progressTicking = false;
  function updateProgress() {
    var max = document.documentElement.scrollHeight - window.innerHeight;
    progressFill.style.transform = 'scaleX(' + (max > 0 ? window.scrollY / max : 0) + ')';
    progressTicking = false;
  }
  window.addEventListener('scroll', function () {
    if (!progressTicking) {
      progressTicking = true;
      requestAnimationFrame(updateProgress);
    }
  }, { passive: true });
  updateProgress();

  var revealObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      });
    },
    { threshold: 0.2, rootMargin: '0px 0px -8% 0px' }
  );

  document.querySelectorAll('.ampion-reveal').forEach(function (el) {
    revealObserver.observe(el);
  });

  var barObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-charged');
        barObserver.unobserve(entry.target);
      });
    },
    { threshold: 0.4 }
  );

  document.querySelectorAll('.ampion-power-bar[data-autocharge]').forEach(function (el) {
    barObserver.observe(el);
  });

  function animateCount(el) {
    var target = parseFloat(el.dataset.countTo || '0');
    var suffix = el.dataset.countSuffix || '';
    var decimals = (el.dataset.countTo || '').split('.')[1]?.length || 0;
    var duration = 1400;
    var start = null;

    function step(timestamp) {
      if (start === null) start = timestamp;
      var progress = Math.min((timestamp - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var value = target * eased;
      el.textContent = value.toFixed(decimals) + suffix;
      if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }

  var counterObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        animateCount(entry.target);
        counterObserver.unobserve(entry.target);
      });
    },
    { threshold: 0.5 }
  );

  document.querySelectorAll('[data-count-to]').forEach(function (el) {
    counterObserver.observe(el);
  });

  // Cursor glow (desktop hero only), driven off rAF, never React/style-thrash on every event.
  document.querySelectorAll('.ampion-cursor-glow').forEach(function (glow) {
    var spot = glow.querySelector('.ampion-cursor-glow__spot');
    if (!spot) return;
    var target = { x: 0, y: 0 };
    var current = { x: 0, y: 0 };
    var raf = null;

    function loop() {
      current.x += (target.x - current.x) * 0.12;
      current.y += (target.y - current.y) * 0.12;
      spot.style.transform = 'translate(' + current.x + 'px, ' + current.y + 'px)';
      raf = requestAnimationFrame(loop);
    }

    glow.parentElement.addEventListener('pointermove', function (e) {
      var rect = glow.getBoundingClientRect();
      target.x = e.clientX - rect.left;
      target.y = e.clientY - rect.top;
      if (raf === null) raf = requestAnimationFrame(loop);
    });

    glow.parentElement.addEventListener('pointerleave', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = null;
    });
  });

  // Sticky header: solidify on scroll.
  var header = document.querySelector('[data-ampion-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 24);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // FAQ accordion chevron rotation is pure CSS via [open]; nothing to wire here.

  // Page-transition power bar on internal navigation.
  var pageBar = document.querySelector('[data-ampion-page-bar]');
  if (pageBar) {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href]');
      if (!link || link.target === '_blank' || link.href.indexOf(window.location.origin) !== 0) return;
      if (link.href === window.location.href) return;
      pageBar.classList.add('is-charged');
    });
  }
})();
